import type { flatten as vFlatten, InferOutput } from 'valibot';
import {
  object as vObject,
  picklist as vPickList,
  string as vString,
  optional as vOptional,
} from 'valibot';

export type ProposalAnswerType = InferOutput<typeof ProposalAnswerTypeSchema>;
export const ProposalAnswerTypeSchema = vPickList(['accept', 'reject']);

export type AgentLeadAnswerParamsIssues = ReturnType<typeof vFlatten<typeof AgentLeadAnswerParamsSchema>>;
export type AgentLeadAnswerParams = InferOutput<typeof AgentLeadAnswerParamsSchema>;
export const AgentLeadAnswerParamsSchema = vObject({
  answerType: ProposalAnswerTypeSchema,
  token: vString(),
});

export type LeadProposalCurrentStatus = InferOutput<typeof LeadProposalCurrentStatusSchema>;
export const LeadProposalCurrentStatusSchema = vPickList(['accepted', 'rejected']);

export const LeadProposalCurrentStatusErrorSchema = vObject({
  currentStatus: vOptional(LeadProposalCurrentStatusSchema),
});
